import { gql } from 'urql';

import { PRODUCT } from '../client';

export const BULK_UPDATE_ROUTE_STOPS_DELIVERY_INFO = gql`
  mutation ${PRODUCT}BulkUpdateRouteStopsDeliveryInfo($input: BulkUpdateRouteStopsDeliveryInfoInput!) {
    bulkUpdateRouteStopsDeliveryInfo(input: $input) {
      route {
        id
      }
      userErrors {
        __typename
        ... on BulkUpdateDeprecated {
          errorCode
          message
        }
      }
    }
  }
`;
